import cloudStore from "../store/CloudStore";

export default (currency = null) => {
  if (!cloudStore.merchant) {
    return "€";
  }

  if (currency == null) {
    currency = cloudStore.merchant.currency;
  }

  if (currency == null) {
    return "€";
  } else {
    switch (currency) {
      case "ang":
        return "ƒ";
      default:
        return "€";
    }
  }
};
